import { z } from 'zod';

export const chainNodeSchema = z.object({
  userId: z.string(),
  isVerified: z.boolean(),
  kycLevel: z.number().int().min(0).max(3),
  avatarUrl: z.string().nullable(),
  followerCount: z.number().int().nonnegative(),
  verifiedFollowerPercent: z.number().int().min(0).max(100),
});

export const delegationChainSchema = z.array(chainNodeSchema);

export const delegationLinkSchema = z.object({
  fromUserId: z.string(),
  toUserId: z.string(),
});

export const delegationMutationResponseSchema = z.object({
  delegation: delegationLinkSchema.nullable(),
  root: chainNodeSchema.nullable(),
});

export const delegationChangeRequestSchema = z.object({
  id: z.string(),
  requesterId: z.string(),
  currentToUserId: z.string().nullable(),
  requestedToUserId: z.string().nullable(),
  status: z.string(),
  createdAt: z.string().or(z.date()),
  updatedAt: z.string().or(z.date()),
});

export const pendingDelegationChangeRequestSchema = z.object({
  request: delegationChangeRequestSchema.nullable(),
});

export const delegationChangeRequestActionSchema = z.object({
  request: delegationChangeRequestSchema,
  delegation: delegationLinkSchema.nullable().optional(),
  root: chainNodeSchema.nullable().optional(),
});

export type ChainNode = z.infer<typeof chainNodeSchema>;
export type DelegationChangeRequest = z.infer<
  typeof delegationChangeRequestSchema
>;
